import {connect} from 'react-redux'
import * as action from '../../state/upload/action'
import * as selector from '../../state/upload/selector'
import CSVUpload from './CSVUpload'

const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
    }
}

const mapDispatchToProps = {
    uploadDBCSV: action.uploadDBCSV,
    uploadPostFinanceCSV: action.uploadPostFinanceCSV,
    uploadZABCSV: action.uploadZABCSV,
    uploadTabeoCSV: action.uploadTabeoCSV,
    uploadSplitItCSV: action.uploadSplitItCSV,
}

export default connect(mapStateToProps, mapDispatchToProps)(CSVUpload)



// WEBPACK FOOTER //
// ./src/modules/payment/component/upload/CSVUploadContainer.js